import { useEffect } from "react";
import './Crop.css';
import React, { useRef } from "react";
import { TextField } from '@mui/material';
// import Cropper from "react-cropper";
// import "cropperjs/dist/cropper.css";
import Button from '@mui/material/Button';
import Cropper from "react-easy-crop";
import Slider from "@mui/material/Slider";
// import Button from "@mui/material/Button";

import { getCroppedImg } from "../utils/cropImage";
import { useHistory } from "react-router-dom";
// Components
import IonicPageWrapper from '../../components/IonicPageWrapper/IonicPageWrapper';
import { IonButton, IonButtons, IonContent, IonHeader, IonModal, IonTitle, IonToolbar } from "@ionic/react";

function Crop() {
	const history = useHistory()
	const inputRef = React.useRef();

	const triggerFileSelectPopup = () => inputRef.current.click();

	const [image, setImage] = React.useState(localStorage.getItem('Img'));
	const [croppedImageURL, setCroppedImageURL] = React.useState(null);
	const [croppedArea, setCroppedArea] = React.useState(null);
	const [crop, setCrop] = React.useState({ x: 0, y: 0 });
	const [zoom, setZoom] = React.useState(1);

	const ALLOWED_FORMATS = [
	    "image/jpeg",
	    "image/jpg",
	    "image/bmp",
	    "image/png",
	    "image/webp",
	    "image/tiff",
	    "image/tif",
	    "image/bitmap",
	    "image/raw",
	    "image/rgb",
	    "image/jfif",
	    "image/Izw",
	]; // Added allowed formats array
	
	// MODAL
	const [isModalOpen, setIsModalOpen] = React.useState(false);
	// 

	const onCropComplete = (croppedAreaPercentage, croppedAreaPixels) => {
		setCroppedArea(croppedAreaPixels);
	};

	const onSelectFile = (event) => {
		if (event.target.files && event.target.files.length > 0) {
			const file = event.target.files[0]; // Get selected file
		        const fileType = file.type; // Extract file type
		
		        if (!ALLOWED_FORMATS.includes(fileType)) { // Check if file type is allowed
		            alert(`Unsupported file format: ${fileType}. Please upload a valid image.`);
		            return; // Stop further execution for invalid formats
		        }
			const reader = new FileReader();
			reader.readAsDataURL(event.target.files[0]);
			reader.addEventListener("load", () => {
				setImage(reader.result);
				localStorage.setItem('Img', reader.result);
			});
		}
	};

	const onDownload = async () => {
		// generateDownload(image, croppedArea);

		if (!croppedArea || !image) return;

		const canvas = await getCroppedImg(image, croppedArea);

		canvas.toBlob(
			(blob) => {
				// const previewUrl = window.URL.createObjectURL(blob);

				// const anchor = document.createElement("a");
				// anchor.download = "image.jpeg";
				// anchor.href = URL.createObjectURL(blob);
				// anchor.click();

				// window.URL.revokeObjectURL(previewUrl);
				setCroppedImageURL(URL.createObjectURL(blob));
				setIsModalOpen(true);
			},
			"image/png",
			0.66
		);
	};

	return (
		<IonicPageWrapper headerTitle='Crop' >
			<div id="crop">
				<section className='crop_cont' >
					<div className='imgCropper_cont'>
						{image ? (
							<>
								<div className='cropper'>
									<Cropper
										image={image}
										crop={crop}
										zoom={zoom}
										aspect={1}
										onCropChange={setCrop}
										onZoomChange={setZoom}
										onCropComplete={onCropComplete}
									/>
								</div>
								<h4>Adjust Photo in the box</h4>

								{/* <div className='slider'>
									<Slider
										min={1}
										max={3}
										step={0.1}
										value={zoom}
										onChange={(e, zoom) => setZoom(zoom)}
									/>
								</div> */}
							</>
						) : null}
					</div>

					<div className='crop_btnsCont'>
						<input
							type='file'
							accept='image/*'
							ref={inputRef}
							onChange={onSelectFile}
							style={{ display: "none" }}
						/>
						<Button variant='contained' color='primary' onClick={triggerFileSelectPopup} style={{ marginRight: "5px" }}>
							Select Image
						</Button>
						{/* <Button variant='contained' color='secondary' onClick={onDownload} style={{ marginLeft: "5px" }}>
							Download
						</Button> */}
						<Button variant='contained' color='secondary' onClick={onDownload} style={{ marginLeft: "5px" }}>
							Crop
						</Button>
					</div>
				</section>

				<IonModal mode='ios' isOpen={isModalOpen} >
					<IonHeader>
						<IonToolbar>
							<IonButtons slot="start">
								<IonButton onClick={() => setIsModalOpen(false)}>{'<'}</IonButton>
							</IonButtons>
							<IonTitle>Preview</IonTitle>
						</IonToolbar>
					</IonHeader>
					<IonContent className="ion-padding" fullscreen >
						<img src={croppedImageURL} />
					</IonContent>
				</IonModal>
			</div>
		</IonicPageWrapper>
	)
}

export default Crop
